import axios from 'axios';
import properties from '../../properties';

export const updatePlan = async (
  id: string,
  updateFields: any,
  handleOpenSnackBar: any,
) => {
  return await axios
    .post(
      properties.aiqBaseUrl +
        properties.contractBaseUrl +
        properties.updatePlan,
      {
        plan_id: id,
        updateFields,
      },
    )
    .then((response) => {
      if (response.status === 200) {
        return response?.data?.data;
      }
    })
    .catch((error) => {
      handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
    });
};
